import { action } from '@ember/object';
import { service } from '@ember/service';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';

export default class RolesTableTableCellUserSelectComponent extends DropdownActivator {
  @service store;

  get people() {
    return this.args.params?.people?.content;
  }

  get firstPerson() {
    return this.people[0];
  }

  get restCount() {
    return this.people.length - 1;
  }

  get restPeople() {
    return this.people.slice(1).map((person) => person.name);
  }

  get body() {
    return document.body;
  }

  get role() {
    return this.args.params;
  }

  @action
  handlePeopleSelect(e) {
    const role = this.role;
    role.people = e;
    role.save();
  }
}
